import {TComponentPayload} from "../../interfaces/email";

export const toComponentPayload = (c: TComponentPayload): TComponentPayload => ({
  order: c.order,
  type: c.type,
  contenu: c.contenu ?? null,
  label: c.label ?? null,
  url: c.url ?? null,
  alt: c.alt ?? null,
  img: c.img ?? null,
  urlType: c.urlType ?? null,
});

export const toComponentPayloads = (components: TComponentPayload[] = []): TComponentPayload[] =>
  components.map(toComponentPayload);
